import './App.css';
import { BlueskyLogo, MastodonLogo, TumblrLogo } from './svgAssets';

const links = [
  {
    label: 'Bluesky',
    slug: 'bluesky',
    url: 'https://bsky.app/profile/aprocryphan.eu',
    description: '@aprocryphan.eu',
    icon: BlueskyLogo,
    glow: '#4987FB',
  },
  {
    label: 'Mastodon',
    slug: 'mastodon',
    url: 'https://mastodon.social/@aprocryphan',
    description: '@aprocryphan',
    icon: MastodonLogo,
    glow: '#5C4DE3',
  },
  {
    label: 'Tumblr',
    slug: 'tumblr',
    url: 'https://aprocryphan.tumblr.com',
    description: 'aprocryphan.tumblr.com',
    icon: TumblrLogo,
    glow: '#36465D',
  },
];

function App() {
  return (
    <div className="linktree-root">
      <header className="hero">
        <div className="hero-badge">aprocryphan.eu</div>
        <h1>Social medias</h1>
        <p>Hi, here are all my social links. I don't use any other social media platforms other than these to post my content.</p>
      </header>

      <main className="link-list">
        {links.map((link) => {
          const Icon = link.icon;

          return (
            <a
              key={link.label}
              href={link.url}
              target="_blank"
              rel="noopener noreferrer"
              className={`link-card link-card--${link.slug}`}
              style={{ '--brand-glow': link.glow }}
            >
              <span className="link-icon" aria-hidden="true">
                <Icon />
              </span>
              <span className="link-copy">
                <span className="link-label">{link.label}</span>
                <span className="link-meta">{link.description}</span>
              </span>
            </a>
          );
        })}
      </main>
    </div>
  );
}

export default App;
